export const HEADING = 'Your blood pressure status';
